import React from 'react'

function Runing_bar() {
  return (
    <>
      <style>{`
        .scroll-left {
        overflow: hidden;
        background-color:white;
        color: var(--color-indigo);
        }
        .scroll-left h1{
        font-size:12px;
        letter-spacing:1px;
        font-weight:bold;
        transform:translateX(100%);
        animation: scroll-left 20s linear infinite;
        user-select: none;
        }
        .scroll-left h2{
        font-size:9px;
        letter-spacing:1px;
        font-weight:bold;
        transform:translateX(100%);
        animation: scroll-left 20s linear infinite;
        user-select: none;
        }
        @keyframes scroll-left {
        0%   {
        transform: translateX(100%); }
        100% {transform: translateX(-100%); }
        }
      `}</style>
      <div>
        {/* <div class="scroll-left">
          <h2 className="pt-2 d-md-none d-sm-block text-cente">
            🎉 Diwali Special Offer! Enjoy a{' '}
            <b className="text-danger">Upto 70% OFF</b> discount on selected
            mentor-led programs. Enhance your learning journey with this
            limited-time offer! 🌟📚✨
          </h2>
          <h1 className="pt-2 text-center d-none d-md-block">
          🎉 Diwali Special Offer! Enjoy a{' '}
            <b className="text-danger">Upto 70% OFF</b> discount on selected
            mentor-led programs. Enhance your learning journey with this
            limited-time offer! 🌟📚✨
          </h1>
        </div> */}
      </div>
    </>
  )
}
export default Runing_bar
